export default __webpack_public_path__ + "static/media/dark_users_icon.5e34ff52.svg";